export const KPI_LIST = [
    { key: "sales", title: "総売上", rateKey: null, round: true },
    { key: "marginal_profit", title: "限界利益額", rateKey: "marginal_profit_rate", round: true },
    { key: "operating_profit_after_fixed", title: "営業利益", rateKey: "operating_profit_after_fixed_rate", round: true },
    // キー名は歴史的経緯で直感と逆（ラベル交差ではない）。
    // total_advertising = 販促費（ポイント+メルマガ+アフィリ+全広告の広義計）、total_promotion = 広告費（純広告のみの計）
    { key: "total_advertising", title: "販促費", rateKey: "total_advertising_rate", round: true },
    { key: "total_promotion", title: "広告費", rateKey: "total_promotion_rate", round: true },
    { key: "point_amount_spent", title: "店舗負担ポイント", rateKey: "point_amount_spent_rate", round: true },
    { key: "coupon_shop", title: "クーポン", rateKey: "coupon_rate", round: true },
    { key: "mail_amount_spent", title: "メルマガ費用", rateKey: "mail_amount_spent_rate", round: true },
    { key: "afl_amount_spent", title: "アフィリエイト", rateKey: "afl_amount_spent_rate", round: true },
] as const;

export type KpiKey = (typeof KPI_LIST)[number]["key"];
